export default __webpack_public_path__ + "static/media/L2.a90fe491.svg";